<template>
  <PageHeader
    :image="RegulamentoBannerImage"
    ariaLabel="Mulher em pose de largada"
    :minHeight="421"
    title="Regulamento"
  />
</template>

<script>
import PageHeader from '@/components/PageHeader'
import RegulamentoBannerImage from '@/images/regulamentoBanner.jpg'

export default {
  name: 'BannerRegulamento',
  components: {
    PageHeader,
  },
  data: () => ({
    RegulamentoBannerImage,
  })
}
</script>
